module.exports = __webpack_public_path__ + "img/not-open-exam.6d0fa053.svg";